import { useCallback, useState, useEffect } from "react"
import { useThrottledCallback } from "use-debounce"

export const SCREEN_BREAKPOINTS = {
  xs: 321,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1500
} as const

type TScreenSize = keyof typeof SCREEN_BREAKPOINTS

const useBreakpoint = (size: TScreenSize) => {
  const [state, setState] = useState<boolean | undefined>()

  const handleResize = useCallback(
    () => setState(screenSizeIsOver(size)),
    [size]
  )
  const handleResizeThrottled = useThrottledCallback(handleResize, 10)

  useEffect(() => handleResize(), [handleResize])

  useEffect(() => {
    window.addEventListener("resize", handleResizeThrottled)

    return () => {
      window.removeEventListener("resize", handleResizeThrottled)
    }
  }, [handleResizeThrottled])

  return state
}

const screenSizeIsOver = (size: TScreenSize) =>
  typeof window !== "undefined" && window.innerWidth >= SCREEN_BREAKPOINTS[size]

export default useBreakpoint
